import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-printer-menu',
  templateUrl: './printer-menu.component.html',
  styleUrls: ['./printer-menu.component.styl']
})
export class PrinterMenuComponent implements OnInit {
  constructor(
    public sql: SQLService,
    public popover: PopoverController,
    private router: Router) {
  }
  list:string;
  dismissPopover(e) {
    if (this.popover) this.popover.dismiss(e);
  }
  delete() {this.dismissPopover('delete');}
  test() {this.dismissPopover('test');}
  default() {this.dismissPopover('default');}
  ngOnInit() {
  }
}